export const COPY_SCREENS = [
    { id: "common", label: "공통" },
    { id: "journey", label: "진행 단계" },
    { id: "attract", label: "시작 화면" },
    { id: "themeSelect", label: "테마 선택" },
    { id: "styleSelect", label: "스타일 선택" },
    { id: "consent", label: "개인정보 동의" },
    { id: "preview", label: "사진 촬영" },
    { id: "generate", label: "AI 생성" },
    { id: "review", label: "결과 확인" },
    { id: "videoIntro", label: "영상 소개" },
    { id: "videoMotions", label: "동작 선택" },
    { id: "videoCaption", label: "자막 입력" },
    { id: "videoGenerate", label: "영상 생성" },
    { id: "payment", label: "결제" },
    { id: "printShare", label: "사진 받기" },
    { id: "thanks", label: "마침" },
    { id: "lock", label: "사용 중지" },
    { id: "print", label: "인쇄 중" },
    { id: "idle", label: "무동작 안내" },
];
export const COPY_CATALOG = [
    // common
    { key: "common.back", screen: "common", label: "뒤로 버튼" },
    { key: "common.brandCaption", screen: "common", label: "브랜드 캡션" },
    { key: "common.brandTag", screen: "common", label: "브랜드 태그" },
    { key: "common.home", screen: "common", label: "처음으로 버튼 (헤더·안내)" },
    { key: "common.keepGoing", screen: "common", label: "계속하기 버튼 (확인·무동작 안내)" },
    { key: "common.homeConfirmTitle", screen: "common", label: "처음으로 확인 제목" },
    { key: "common.homeConfirmBody", screen: "common", label: "처음으로 확인 본문" },
    // idle (전역 무동작 안내 — 120초 뒤 30초 카운트다운)
    { key: "idle.title", screen: "idle", label: "제목" },
    { key: "idle.body", screen: "idle", label: "본문 (남은 초)", params: ["sec"] },
    // journey (스텝퍼 5단계)
    { key: "journey.theme", screen: "journey", label: "1단계 · 테마 선택" },
    { key: "journey.style", screen: "journey", label: "2단계 · 스타일 선택" },
    { key: "journey.capture", screen: "journey", label: "3단계 · 사진 촬영" },
    { key: "journey.result", screen: "journey", label: "4단계 · 결과 확인" },
    { key: "journey.receive", screen: "journey", label: "5단계 · 사진 받기" },
    // attract
    { key: "attract.tagline", screen: "attract", label: "태그라인" },
    { key: "attract.headline", screen: "attract", label: "메인 헤드라인", multiline: true },
    { key: "attract.cta", screen: "attract", label: "시작 버튼" },
    // themeSelect
    { key: "themeSelect.title", screen: "themeSelect", label: "제목" },
    { key: "themeSelect.count", screen: "themeSelect", label: "테마 개수", params: ["n"] },
    { key: "themeSelect.cta", screen: "themeSelect", label: "선택 버튼" },
    { key: "themeSelect.storiesLabel", screen: "themeSelect", label: "카드 '담긴 이야기' 라벨" },
    // styleSelect
    { key: "styleSelect.back", screen: "styleSelect", label: "뒤로(테마 다시 고르기)" },
    { key: "styleSelect.title", screen: "styleSelect", label: "제목" },
    { key: "styleSelect.cta", screen: "styleSelect", label: "선택 버튼" },
    { key: "styleSelect.next", screen: "styleSelect", label: "다음 스타일 버튼" },
    // consent
    { key: "consent.title", screen: "consent", label: "제목", multiline: true },
    { key: "consent.required", screen: "consent", label: "필수 배지" },
    { key: "consent.view", screen: "consent", label: "항목 보기 버튼" },
    { key: "consent.close", screen: "consent", label: "닫기 버튼" },
    { key: "consent.allAgree", screen: "consent", label: "전체 동의 버튼" },
    { key: "consent.processor", screen: "consent", label: "개인정보처리자", params: ["name"] },
    { key: "consent.contact", screen: "consent", label: "문의 연락처", params: ["contact"] },
    { key: "consent.refusal", screen: "consent", label: "동의 거부 효과 안내" },
    { key: "consent.cta", screen: "consent", label: "동의 버튼(짝 버튼 오른쪽)" },
    { key: "consent.decline", screen: "consent", label: "미동의 버튼(짝 버튼 왼쪽)" },
    { key: "consent.back", screen: "consent", label: "뒤로(스타일 선택으로)" },
    // preview
    { key: "preview.back", screen: "preview", label: "뒤로(스타일 다시 고르기)" },
    { key: "preview.title", screen: "preview", label: "제목", multiline: true },
    { key: "preview.tip1", screen: "preview", label: "안내 1" },
    { key: "preview.tip2", screen: "preview", label: "안내 2 (카운트다운)", params: ["sec"] },
    { key: "preview.tip3", screen: "preview", label: "안내 3" },
    { key: "preview.placeholderTitle", screen: "preview", label: "카메라 대기 제목" },
    { key: "preview.placeholderBody", screen: "preview", label: "카메라 대기 본문", multiline: true },
    { key: "preview.connecting", screen: "preview", label: "연결 중" },
    { key: "preview.shoot", screen: "preview", label: "촬영 버튼" },
    { key: "preview.openCamera", screen: "preview", label: "카메라 켜기 버튼 (폰)" },
    { key: "preview.closeCamera", screen: "preview", label: "안내로 돌아가기 (폰)" },
    { key: "preview.cancel", screen: "preview", label: "촬영 취소 버튼" },
    { key: "preview.retry", screen: "preview", label: "카메라 재연결 버튼" },
    { key: "preview.note", screen: "preview", label: "촬영 안내 주석" },
    { key: "preview.holdStill", screen: "preview", label: "촬영 직전 문구" },
    { key: "preview.confirmTitle", screen: "preview", label: "촬영 확인 제목" },
    { key: "preview.confirmHint", screen: "preview", label: "촬영 확인 안내" },
    { key: "preview.confirmRetake", screen: "preview", label: "다시 찍기 버튼 (확인)" },
    { key: "preview.confirmProceed", screen: "preview", label: "이대로 진행 버튼 (확인)" },
    { key: "preview.errorTitle", screen: "preview", label: "카메라 오류 제목" },
    { key: "preview.errorTitleNoDevice", screen: "preview", label: "카메라 없음 제목" },
    { key: "preview.errorPermissionDenied", screen: "preview", label: "권한 거부 안내" },
    { key: "preview.errorNoDevice", screen: "preview", label: "카메라 없음 안내" },
    { key: "preview.errorInsecureContext", screen: "preview", label: "HTTPS 필요 안내" },
    { key: "preview.errorTimeout", screen: "preview", label: "응답 없음 안내" },
    { key: "preview.errorUnknown", screen: "preview", label: "알 수 없는 오류 안내" },
    // generate
    { key: "generate.title", screen: "generate", label: "제목" },
    { key: "generate.hint", screen: "generate", label: "소요 시간 안내" },
    { key: "generate.selectedLabel", screen: "generate", label: "스타일 칩 킥커 (영문 고정)" },
    { key: "generate.developing", screen: "generate", label: "진행 라벨 (영문 고정)" },
    { key: "generate.step0", screen: "generate", label: "진행 단계 1" },
    { key: "generate.step1", screen: "generate", label: "진행 단계 2" },
    { key: "generate.step2", screen: "generate", label: "진행 단계 3" },
    { key: "generate.step3", screen: "generate", label: "진행 단계 4" },
    { key: "generate.remaining", screen: "generate", label: "남은 시간", params: ["sec"] },
    { key: "generate.almostDone", screen: "generate", label: "거의 완료" },
    { key: "generate.queueWait", screen: "generate", label: "대기열 안내" },
    { key: "generate.tookTooLong", screen: "generate", label: "지연 안내" },
    { key: "generate.failed", screen: "generate", label: "실패 제목" },
    { key: "generate.cancel", screen: "generate", label: "취소 버튼" },
    { key: "generate.retry", screen: "generate", label: "다시 시도 버튼" },
    { key: "generate.proceed", screen: "generate", label: "그대로 진행 버튼" },
    { key: "generate.back", screen: "generate", label: "촬영으로 돌아가기" },
    // review
    { key: "review.title", screen: "review", label: "완성 제목" },
    { key: "review.retake", screen: "review", label: "다시 찍기 버튼" },
    { key: "review.next", screen: "review", label: "사진 받기 버튼" },
    { key: "review.makeVideo", screen: "review", label: "영상 만들기 버튼" },
    { key: "review.makeVideoPriced", screen: "review", label: "영상 만들기 버튼 (가격 포함, 결제 ON)", params: ["price"] },
    { key: "review.slotError", screen: "review", label: "변환 실패 라벨" },
    // videoIntro (BOOTH-60 1b-2 — 샘플 영상 루프로 "움직이는 화보" 소개, 캔버스 9.1)
    { key: "videoIntro.back", screen: "videoIntro", label: "결과로 돌아가기" },
    { key: "videoIntro.title", screen: "videoIntro", label: "제목", multiline: true },
    { key: "videoIntro.body", screen: "videoIntro", label: "소개 문구", multiline: true },
    { key: "videoIntro.cta", screen: "videoIntro", label: "만들기 버튼" },
    { key: "videoIntro.skip", screen: "videoIntro", label: "사진만 버튼" },
    // videoMotions (BOOTH-60 1b — 동작 1~2개 순서 선택)
    { key: "videoMotions.back", screen: "videoMotions", label: "결과로 돌아가기" },
    { key: "videoMotions.title", screen: "videoMotions", label: "제목" },
    { key: "videoMotions.subtitle", screen: "videoMotions", label: "부제 (순서 안내)" },
    { key: "videoMotions.hint", screen: "videoMotions", label: "미선택 안내" },
    { key: "videoMotions.next", screen: "videoMotions", label: "다음 버튼" },
    // videoCaption (BOOTH-85 — 손님이 남기는 한 줄, 영상 하단 안쪽에 그늘과 함께 겹친다(2026-10-19, 종이색 띠 폐기). 캔버스 9.3)
    { key: "videoCaption.back", screen: "videoCaption", label: "뒤로 버튼" },
    { key: "videoCaption.title", screen: "videoCaption", label: "제목" },
    { key: "videoCaption.subtitle", screen: "videoCaption", label: "부제 (영상 아래 자막 안내)" },
    { key: "videoCaption.placeholder", screen: "videoCaption", label: "입력칸 안내 (최대 글자수)" },
    { key: "videoCaption.preset1", screen: "videoCaption", label: "프리셋 문구 1" },
    { key: "videoCaption.preset2", screen: "videoCaption", label: "프리셋 문구 2" },
    { key: "videoCaption.preset3", screen: "videoCaption", label: "프리셋 문구 3" },
    { key: "videoCaption.preset4", screen: "videoCaption", label: "프리셋 문구 4" },
    { key: "videoCaption.next", screen: "videoCaption", label: "다음 버튼 (자막 넣기)" },
    { key: "videoCaption.skip", screen: "videoCaption", label: "넣지 않기 버튼" },
    // videoGenerate
    { key: "videoGenerate.back", screen: "videoGenerate", label: "결과로 돌아가기" },
    { key: "videoGenerate.title", screen: "videoGenerate", label: "제목 (영상 제작 시작 중)" },
    { key: "videoGenerate.caption", screen: "videoGenerate", label: "부제 (영상은 QR 로 나중에 전달)" },
    { key: "videoGenerate.error", screen: "videoGenerate", label: "실패 문구" },
    { key: "videoGenerate.retry", screen: "videoGenerate", label: "다시 시도 버튼" },
    { key: "videoGenerate.skipToPhoto", screen: "videoGenerate", label: "사진만 받기 버튼" },
    { key: "videoGenerate.refunded", screen: "videoGenerate", label: "영상 실패 시 자동 환불 안내 (결제 ON)" },
    // payment (BOOTH-61/74 — 결제 유효 ON 부스, 영상 생성 직전. 캔버스 10)
    { key: "payment.title", screen: "payment", label: "제목" },
    { key: "payment.cancel", screen: "payment", label: "취소 버튼" },
    { key: "payment.kicker", screen: "payment", label: "QR 킥커 (영문 고정)" },
    { key: "payment.itemPhoto", screen: "payment", label: "내역 — 사진 인화" },
    { key: "payment.itemVideo", screen: "payment", label: "내역 — 움직이는 화보" },
    { key: "payment.total", screen: "payment", label: "내역 — 합계 라벨" },
    { key: "payment.qrHeading", screen: "payment", label: "QR 박스 제목" },
    { key: "payment.qrHint", screen: "payment", label: "QR 안내 (카메라로 비추기)" },
    { key: "payment.methods", screen: "payment", label: "결제 수단 나열" },
    { key: "payment.noticeVideo", screen: "payment", label: "안내 — 영상 포함 (결제 전엔 만들지 않음)", multiline: true },
    { key: "payment.noticePhoto", screen: "payment", label: "안내 — 사진만" },
    { key: "payment.remaining", screen: "payment", label: "남은 시간 (mm:ss)", params: ["time"] },
    { key: "payment.wifiHint", screen: "payment", label: "매장 Wi-Fi 안내" },
    { key: "payment.connectionLost", screen: "payment", label: "배너 — 폴링 10초 이상 실패" },
    { key: "payment.failedHint", screen: "payment", label: "배너 — 결제 거절(재시도 가능)" },
    { key: "payment.unavailable", screen: "payment", label: "에러 — 결제 사용 불가 (직원 호출)", multiline: true },
    { key: "payment.createError", screen: "payment", label: "에러 — 결제 준비 실패 (다시 시도)" },
    { key: "payment.expired", screen: "payment", label: "결과 화면 안내 — 시간 만료" },
    { key: "payment.closed", screen: "payment", label: "결과 화면 안내 — 취소됨" },
    // printShare
    { key: "printShare.title", screen: "printShare", label: "제목" },
    { key: "printShare.kicker", screen: "printShare", label: "QR 킥커 (영문 고정)" },
    { key: "printShare.qrHeading", screen: "printShare", label: "QR 박스 제목" },
    { key: "printShare.desc1", screen: "printShare", label: "QR 설명 1", multiline: true },
    { key: "printShare.desc2", screen: "printShare", label: "QR 설명 2", multiline: true, params: ["days"] },
    { key: "printShare.privacy", screen: "printShare", label: "프라이버시 안내", multiline: true, params: ["days"] },
    { key: "printShare.printCta", screen: "printShare", label: "인쇄 버튼" },
    { key: "printShare.retake", screen: "printShare", label: "다시 찍기 버튼" },
    { key: "printShare.home", screen: "printShare", label: "처음으로 버튼" },
    { key: "printShare.doneCta", screen: "printShare", label: "완료 버튼 (부스 인쇄 꺼짐)" },
    { key: "printShare.shareHint", screen: "printShare", label: "공유 시트 인쇄 안내 (부스 인쇄 경로 = 공유 시트)" },
    { key: "printShare.bodyWithVideo", screen: "printShare", label: "영상 포함 안내 (영상 완료)", multiline: true },
    { key: "printShare.bodyVideoPending", screen: "printShare", label: "영상 제작 중 안내 (지연 전달)", multiline: true },
    { key: "printShare.bodyVideoFailed", screen: "printShare", label: "영상 실패 안내 (지연 전달)", multiline: true },
    { key: "printShare.videoPendingLabel", screen: "printShare", label: "영상 카드 제작 중 라벨" },
    { key: "printShare.photoLabel", screen: "printShare", label: "사진 카드 라벨 (영상 함께 표시 시)" },
    { key: "printShare.videoLabel", screen: "printShare", label: "영상 카드 라벨 (영상 함께 표시 시)" },
    { key: "printShare.uploading", screen: "printShare", label: "업로드 상태" },
    { key: "printShare.uploadError", screen: "printShare", label: "업로드 실패 안내" },
    { key: "printShare.retry", screen: "printShare", label: "다시 시도 버튼" },
    { key: "printShare.qrAlt", screen: "printShare", label: "QR 대체 텍스트" },
    { key: "printShare.agentOffline", screen: "printShare", label: "프린터 미연결 안내 (에이전트 인쇄)" },
    // thanks
    { key: "thanks.title", screen: "thanks", label: "제목" },
    { key: "thanks.body", screen: "thanks", label: "본문 (자동 복귀 카운트)", params: ["sec"] },
    { key: "thanks.tapHint", screen: "thanks", label: "터치 안내" },
    // lock
    { key: "lock.title", screen: "lock", label: "제목" },
    { key: "lock.body", screen: "lock", label: "본문" },
    // print
    { key: "print.title", screen: "print", label: "제목 — 인쇄 중" },
    { key: "print.sub", screen: "print", label: "부제" },
    { key: "print.status", screen: "print", label: "진행 상태 (인쇄 다이얼로그 모드)" },
    { key: "print.preparing", screen: "print", label: "제목 — 대기 중 (에이전트 인쇄)" },
    { key: "print.delayed", screen: "print", label: "제목 — 지연 안내 (에이전트 인쇄)", multiline: true },
    { key: "print.delayedHint", screen: "print", label: "지연·실패 시 부제 (QR 안내)" },
    { key: "print.failed", screen: "print", label: "제목 — 인쇄 실패 (에이전트 인쇄)", multiline: true },
    { key: "print.paperOut", screen: "print", label: "제목 — 용지 없음 (에이전트 인쇄)", multiline: true },
];
export const COPY_KEYS = COPY_CATALOG.map((e) => e.key);
//# sourceMappingURL=catalog.js.map